import { render, staticRenderFns } from "./IllionStatementUploader.vue?vue&type=template&id=22fb91f3&scoped=true&"
import script from "./IllionStatementUploader.vue?vue&type=script&lang=js&"
export * from "./IllionStatementUploader.vue?vue&type=script&lang=js&"
import style0 from "./IllionStatementUploader.vue?vue&type=style&index=0&id=22fb91f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb91f3",
  null
  
)

export default component.exports